// Shared shape for the write actions added for the v2 CRUD screens: run the request,
// keep the snackbar in step, and tell the caller whether it actually succeeded so a
// dialog only closes on a confirmed write.
//
// `call` is a thunk (not a promise) so nothing is fired before the loading snackbar is up.
export async function request(commit, { call, loading, success, error_timeout = '4000' }) {
  try {
    commit('SET_SNACKBAR', { status: true, color: 'loading', text: loading, loading: true })
    const response = await call()
    if (response.data.success) {
      commit('SET_SNACKBAR', { status: true, color: 'success', text: success, icon: 'check', timeout: '2000' })
      return true
    }
    // Backend refusals (duplicate name, queue still referenced, ...) are shown verbatim.
    commit('SET_SNACKBAR', { status: true, color: 'error', text: response.data.message, icon: 'close', timeout: error_timeout })
    return false
  } catch (error) {
    commit('SET_SNACKBAR', { status: true, color: 'error', text: 'Server Error', icon: 'close', timeout: '3000' })
    return false
  }
}
